import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {FlowPageDataProduct, FlowSummary, QuestionFlowCollation} from '../../models/quote.model';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {FlowPlayerService} from '../../services/flow-player.service';
import {QuestionQuery} from '../state/question.query';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {Alert} from '../../utilities';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { ComponentsService } from '../../services/components-service';
import { SuperflowStore } from '../state/superflow.store';
import { DatePipe } from '@angular/common';
import { PaymentDetailsTransactionTypes } from 'src/app/modules/account/models/enums/payment-details-transaction-types';
import { QuestionType } from '../../constants';

declare var $: any;
declare var initDayOnlyDatepicker: any;

@Component({
  selector: 'app-question-quote-pay',
  templateUrl: './question-quote-pay.component.html',
  styleUrls: ['./question-quote-pay.component.scss'],
  standalone: false
})
export class QuestionQuotePayComponent implements OnInit, OnChanges, OnDestroy {

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() submitResponse = new EventEmitter<any>();
  @Output() showEditModal = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSummaryDataChanged = new EventEmitter<any>();
  @Output() navigateBack = new EventEmitter<void>();

  collations: QuestionFlowCollation[] = [];
  summaryCollations: QuestionFlowCollation[] = [];
  product: FlowPageDataProduct;
  summary = new FlowSummary();
  sessionDetails: any;
  selectedItem: any;
  classes: QuestionFlowCollation[] = [];
  classItems: any[] = [];
  isSavingData = false;
  parameter: any;
  summaryDataSubscription: Subscription;
  user: any;
  window: any['dataLayer'] = window['dataLayer'] || [];
    selectedRecommendation: any
  selectedProduct: any;

  // Pay page data
  coverDateData: any = null;
  debitDateData: any = null;
  debitDateOptions: any[] = [];
  debitDateHeader: string = '';
  payFrequencies: any[] = [];
  payFrequencyHeader: string = '';
  existingPaymentMethods: any[] = [];
  newPaymentMethods: any[] = [];
  paymentMethodHeader: string = '';
  accountTypes: any[] = [
    {value: '1', label: 'Current Account'},
    {value: '2', label: 'Savings Account'},
    {value: '3', label: 'Credit Card Account'},
    {value: '4', label: 'Transaction Account'},
  ];
  banks: any[] = [];
  bankOptions: any[] = [];
  documents: any[] = [];
  verbalConsentQuestion: Question = null;
  person: any = null;
  sendPdfEmail: string = '';
  sendingPdfQuote: boolean = false;
  legalAgreed: boolean = false;
  voiceRecording: boolean = false;
  voiceRecordingQuestion: any;

  // Selections
  selectedFrequencyId: number = 3;
  selectedPaymentMethod: any = null;
  selectedInceptionDate: string = '';
  selectedDebitDate: string = '';
  selectedDebitDay: number | null = null;

  // Payment breakdown
  paymentBreakdown: any = null;
  loadingBreakdown: boolean = false;
  processingPayment: boolean = false;
  resolvedProductId: number = null;

  // Date picker
  minDate: Date = null;
  maxDate: Date = null;
  numberOfMonths: number = 2;
  initialDate: string = '';
  
  constructor(
    public questionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private router: Router,
    public datePipe: DatePipe,
    private userStore: UserStore,
    private QuestionQuery: QuestionQuery,
    private superflowStore: SuperflowStore,
    private componentsService: ComponentsService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
    console.log('sessionDetails', this.sessionDetails);
  }


  ngOnInit(): void {
    this.user = this.userStore.getValue();
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    this.selectedProduct = JSON.parse(sessionStorage.getItem('selectedProduct') || '{}');
    console.log('selectedProduct', this.selectedProduct);
    if (this.user?.broker_id > 0) {
      const verbalConsentQuestion = new Question();
      verbalConsentQuestion.cent_aq_question_id = 1993;
      verbalConsentQuestion.cent_aq_question_type_id = QuestionType.upload_videos;
      this.verbalConsentQuestion = verbalConsentQuestion;
    }
    this.loadBanks();
    this.getPageData();
  }

  loadBanks(): void {
    this.questionService.runCommandNew('getBanks', new Map<string, string>()).subscribe((banks: any[]) => {
      this.banks = banks || [];
      this.bankOptions = this.banks.map(b => ({value: b.bank_id, label: b.bank_name}));
    });
  }
  ngAfterViewInit(): void {
    document.querySelector('body')?.classList.add('page--questions');
    document.querySelector('body')?.classList.add('page--questions-no-tray');
    document.querySelector('body')?.classList.add('page--questions-top-aligned');
  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  getPageData(): void {
    if (this.question) {
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.sessionDetails.session_id);
      parameters.set('category_id', this.sessionDetails.category_id);
      parameters.set('product_group_id', this.sessionDetails.group_id);
      parameters.set('product_id', this.selectedProduct?.product_id);
      parameters.set('frequency_id', this.selectedProduct?.frequency_id || '3');       

      this.questionService.runCommandNew(`getPayPageData`, parameters, true)
        .subscribe((result) => {
          console.log('getPayPageData', result);
          if (result && result.length > 0) {
            this.parsePayPageData(result);
          }
        });
    }
  }

  parsePayPageData(data: any[]): void {
    data.forEach((section: any[]) => {
      if (!section || section.length === 0) return;

      const firstItem = section[0];
            const index = firstItem.index;

      switch (index) {
        case 1: // Cover start date
          this.coverDateData = firstItem;
          console.log('coverDateData', this.coverDateData);
          // Set date picker bounds from API data
          if (firstItem.inception_date_min) {
            this.minDate = new Date(firstItem.inception_date_min);
          }
          if (firstItem.inception_date_max) {
            this.maxDate = new Date(firstItem.inception_date_max);
          }
          // Use saved inception_date if available, else fall back to min date
          this.initialDate = firstItem.inception_date || firstItem.inception_date_min;
          this.selectedInceptionDate = firstItem.inception_date || firstItem.inception_date_min;

          // Persist this as the question-571 answer even if the user never touches the date
          // picker: dateChange() deliberately skips saving on the picker's initial mount-emission
          // (see its comment below), so without this, createPolicy's date_inception guard finds
          // no stored answer for 571 and overwrites a valid inception date with NULL.
          if (this.selectedInceptionDate) {
            const inceptionQuestion = new Question();
            inceptionQuestion.cent_aq_question_id = 571;
            inceptionQuestion.answer = this.datePipe.transform(this.selectedInceptionDate, 'yyyy-MM-dd');
            this.questionService.saveAnswerOnly(inceptionQuestion).subscribe();
          }
          break;
        case 2: // Debit date
          this.debitDateData = firstItem;
          section.forEach(item => {
            if (item.entry_type === 'header') {
              this.debitDateHeader = item.header;
            } else if (item.entry_type === 'debit_option') {
              this.debitDateOptions.push(item);
              if (item.default === 1) {
                this.selectedDebitDay = item.day;
                this.selectedDebitDate = item.date;
              }
            }
          });
          // If no default set, select the first option
          if (this.selectedDebitDay === null && this.debitDateOptions.length > 0) {
            this.selectedDebitDay = this.debitDateOptions[0].day;
            this.selectedDebitDate = this.debitDateOptions[0].date;
          }
          break;
        case 3: // Payment frequencies
          section.forEach(item => {
            if (item.entry_type === 'header') {
              this.payFrequencyHeader = item.header;
            } else if (item.entry_type === 'pay_freq') {
              this.payFrequencies.push(item);
              if (item.default === 1) {
                this.selectedFrequencyId = item.frequency_id;
              }
            }
          });
          break;
        case 5: // Payment methods
          section.forEach(item => {
            if (item.entry_type === 'header') {
              this.paymentMethodHeader = item.header;
            } else if (item.entry_type === 'existing') {
              this.existingPaymentMethods.push(item);
                            if (item.default === 1 && !this.selectedPaymentMethod) {
                this.selectedPaymentMethod = item;
              }
            } else if (item.entry_type === 'new') {
              this.newPaymentMethods.push(item);
            }
          });
          break;
        case 4: // Policy holder
          this.person = firstItem;
          break;
      }
    });

    this.ref.detectChanges();

        // Fetch payment breakdown on initial load
    this.getPaymentBreakdown();

        // Fetch legal documents
    const docParams = new Map<string, string>();
    docParams.set('session_id', this.sessionDetails.session_id);
    docParams.set('frequency_id', String(this.selectedFrequencyId));
    //docParams.set('category_id', String(this.sessionDetails.category_id));
    this.questionService.runCommandNew('getDocuments', docParams)
      .subscribe((docs: any[]) => {
        this.documents = docs;
      });

        // Initialize jQuery components after DOM is updated
    setTimeout(() => {
      this.initSelectables();
      this.initTabNav();
      this.initDebitDateSelect();
      this.initDayOnlyDatepickers();
      this.initExistingAccountTypeSelects();
    }, 100);
  }

  initSelectables(): void {
    $('.selectable')
      .off('change', '.custom-input input[type="radio"]')
      .off('click', '.selectable__head')
      .on('change', '.custom-input input[type="radio"]', function(e: any) {
        e.stopPropagation();
        const $input = $(this);
        const $selectable = $input.closest('.selectable');

        if ($input.is(':checked')) {
          $selectable.addClass('is-selected');
          $selectable.siblings().removeClass('is-selected');
        }
      })
      .on('click', '.selectable__head', function(e: any) {
        e.preventDefault(); // Always prevent default anchor behavior

        const $trigger = $(this);
        const $selectable = $trigger.closest('.selectable');
        const targetHref = $trigger.attr('href');
        const $target = $(targetHref);

        // Trigger radio click if not selected
        if (!$selectable.hasClass('is-selected')) {
          $trigger.find('.custom-input input[type="radio"]').prop('checked', true).trigger('change');
        }

        // Toggle collapse
        if ($target.length) {
          // If already expanded and selected, keep it open
          if ($target.hasClass('show') && $selectable.hasClass('is-selected')) {
            return;
          }

          // Hide other collapses in the same accordion
          const $parent = $($target.data('parent'));
          if ($parent.length) {
            $parent.find('.collapse.show').not($target).collapse('hide');
          }

          // Toggle current target
          $target.collapse('toggle');
        }
      });
  }

    initTabNav(): void {
    $('#pay-method-nav a').off('click').on('click', function(e: any) {
      e.preventDefault();
      const $this = $(this);
      const categoryHash = $this.attr('href');

      $('#pay-method-nav a').parent('li').removeClass('is-active');
      $this.parent('li').addClass('is-active');

      $(categoryHash).addClass('is-active')
        .siblings('.tab-content__item').removeClass('is-active');
    });
  }

  initDebitDateSelect(): void {
    const $select = $('#debit-date-select');
    if (!$select.length) { return; }

    if ($select.selectmenu('instance')) {
      $select.selectmenu('destroy');
    }

    $select.selectmenu({
      change: (event, ui) => {
        const day = parseInt(ui.item.value, 10);
        if (!isNaN(day)) {
          this.selectDebitDate(day);
        }
      }
    });
  }

  initExistingAccountTypeSelects(): void {
    // These display an existing payment method's saved account type; they aren't editable
    // (no change binding), so this only needs to apply the jQuery UI styling.
    const $selects = $('.account-type-existing-select');
    $selects.each(function(): void {
      if ($(this).selectmenu('instance')) {
        $(this).selectmenu('destroy');
      }
    });
    $selects.selectmenu({});
  }

  initDayOnlyDatepickers(): void {
    if (typeof initDayOnlyDatepicker !== 'function') { return; }
    this.existingPaymentMethods.forEach((method: any, i: number) => {
      if (this.isCreditCard(method)) {
        initDayOnlyDatepicker(`#day-only-existing-cc-${i}`);
      }
    });
    this.newPaymentMethods.forEach((method: any, i: number) => {
      if (this.isCreditCard(method)) {
        initDayOnlyDatepicker(`#day-only-new-cc-${i}`);
      }
    });
  }

  getPaymentBreakdown(): void {
    const loadingTimer = setTimeout(() => {
      this.loadingBreakdown = true;
      this.ref.detectChanges();
    }, 1000);

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails.session_id);
    parameters.set('product_id', this.selectedProduct?.product_id);
    parameters.set('frequency_id', String(this.selectedFrequencyId));

    this.questionService.runCommandNew('getPaymentBreakDownData', parameters, true)
      .subscribe((result) => {
        clearTimeout(loadingTimer);
        if (result && result.length > 0 && result[0].length > 0) {
          this.paymentBreakdown = result[0][0];
          if (this.paymentBreakdown?.product_id) {
            // The backend resolves product_id from calc_collation even when we don't pass one,
            // so this is a more reliable source than selectedProduct (cached in sessionStorage
            // by an earlier step, and empty if this page is reached without that step running
            // first in this tab - e.g. a resumed/consent-link session in a fresh browser).
            this.resolvedProductId = this.paymentBreakdown.product_id;
          }
              }
              this.loadingBreakdown = false;
              this.ref.detectChanges();
            });
  }

  selectFrequency(frequency: any): void {
    this.selectedFrequencyId = frequency.frequency_id;
    this.getPaymentBreakdown();
  }

  selectPaymentMethod(method: any): void {
    this.selectedPaymentMethod = method;
  }

  selectAccountType(method: any, value: any): void {
    method.account_type_id = value;
    this.validateDebitOrder(method);
  }

  selectBank(method: any, bankId: any): void {
    const bank = this.banks.find(b => b?.bank_id === +bankId);
    method.bank_id = bank?.bank_id ?? null;
    method.bank_name = bank?.bank_name ?? '';
    method.branch_code = '';
    if (bank?.branches) {
      try {
        const branches = JSON.parse(bank.branches);
        const universalBranch = branches.find((b: any) => b?.universal === 1);
        if (universalBranch) {
          method.branch_code = universalBranch.branch_code;
        }
      } catch (e) { }
    }
    this.validateDebitOrder(method);
  }

  checkRequiredFields(method: any): void {
    method.missing_account_name = !method.account_name;
    method.missing_bank = !method.bank_id;
    method.missing_account_number = !method.account_number;
    method.missing_branch_code = !method.branch_code;
    method.missing_account_type = !method.account_type_id;
  }

  validateDebitOrder(method: any): void {
    this.checkRequiredFields(method);
    if (method.branch_code && method.account_name && method.account_number && method.account_type_id && method.bank_id) {
      this.questionService.validateBankAccount(method.account_number, method.branch_code, String(method.account_type_id))
        .subscribe((result: string) => {
          method.account_number_invalid = false;
          method.branch_code_invalid = false;
          switch (result) {
            case '0':
              method.bank_verified = true;
              this.saveBankAnswer(method);
              break;
            case '1':
              method.bank_verified = false;
              method.branch_code_invalid = true;
              break;
            case '2':
            case '3':
              method.bank_verified = false;
              method.account_number_invalid = true;
              break;
            default:
              method.bank_verified = false;
              Alert('We are unable to verify the details you have entered. Please call or chat to us for further assistance.');
              break;
          }
        });
    } else {
      method.bank_verified = false;
    }
  }

  saveBankAnswer(method: any): void {
    const question = new Question();
    question.cent_aq_question_id = 881;
    question.answer = JSON.stringify({
      transaction_type: PaymentDetailsTransactionTypes.Debit_Order,
      bank_id: method.bank_id,
      bank_name: method.bank_name,
      branch_code: method.branch_code,
      acc_type: this.accountTypes.find(a => a.value === String(method.account_type_id))?.label,
      acc_name: method.account_name,
      acc_no: method.account_number
    });
    this.questionService.saveAnswerOnly(question).subscribe();
  }

  selectDebitDate(day: number): void {
    this.selectedDebitDay = day;
    const option = this.debitDateOptions.find(o => o.day === day);
    if (option) {
      this.selectedDebitDate = option.date;
      const question = new Question();
      question.cent_aq_question_id = 4695;
      question.answer = String(day);
      this.questionService.saveAnswerOnly(question).subscribe({
        next: () => {
          this.getPaymentBreakdown();
        }
      });
    }
  }

  get defaultAttachments(): any[] {
    return this.documents?.filter(d => d.is_default_attachment) ?? [];
  }

  get optionalAttachments(): any[] {
    return this.documents?.filter(d => !d.is_default_attachment) ?? [];
  }

  openDocument(doc: any): void {
    localStorage.setItem('previous-document-page', this.router.url);
    if (doc?.document_url?.indexOf('http') > -1) {
      window.open(doc?.document_url, '_blank');
    } else {
      const params = new URLSearchParams();
      params.set('document_id', doc?.document_id);
      if (doc?.document_name) { params.set('document_name', doc.document_name); }
      if (this.sessionDetails?.session_id) { params.set('session_id', this.sessionDetails.session_id); }
      if (this.selectedProduct?.product_name) { params.set('product_name', this.selectedProduct.product_name); }
      window.open(`/doc-document?${params.toString()}`, '_blank');
    }
  }

  onVerbalConsentUploaded(question: Question): void {
    if (question.answer === 'Not answered' || question.answer === '') {
      this.voiceRecording = false;
    } else {
      this.voiceRecording = true;
    }

    this.questionService.saveAnswerOnly(question).subscribe();
    this.voiceRecordingQuestion = question;
  }

  sendConsentLink(): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails.session_id.toString());
    this.questionService.runCommandNew('resumeFlow', parameters)
      .subscribe((flow: any[]) => {
        const params = new Map<string, string>();
        params.set('event_id', '17');
        params.set('session_id', this.sessionDetails.session_id);
        params.set('email', this.person?.email);
        params.set('key', flow[0]?.full_url);
        this.questionService.runCommandNew('triggerEvent', params)
          .subscribe({
            next: () => {
              Alert('Approval email sent successfully.');
            },
            error: (err) => {
              Alert(err);
            }
          });
      });
  }

  sendPdfQuote(): void {
    if (this.sendingPdfQuote) {
      return;
    }

    if (!this.sendPdfEmail) {
      Alert('Please enter the client\'s email address.');
      return;
    }

    const selectedDocs = [
      ...this.defaultAttachments,
      ...this.optionalAttachments.filter(d => d.selected)
    ].map(d => ({
      document_id: d.document_id,
      document_name: d.document_name,
      document_url: d.document_url
    }));

    if (!selectedDocs.length) {
      Alert('Please select at least one document to send.');
      return;
    }

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails.session_id);
    parameters.set('to_email', this.sendPdfEmail);
    parameters.set('documents_json', JSON.stringify(selectedDocs));

    this.sendingPdfQuote = true;
    this.questionService.runCommandNew('sendQuotePdfPack_worker', parameters).subscribe({
      next: () => {
        this.sendingPdfQuote = false;
        $('#send-pdf-quote-modal').modal('hide');
        Alert('<strong>Success!</strong> The quote was sent to your client.');
      },
      error: (err) => {
        this.sendingPdfQuote = false;
        Alert(err);
      }
    });
  }

  dateChange(event: string): void {
    if (!event) { return; }

    // app-question-date-picker also emits its initial date on mount (ngAfterViewInit),
    // not just on real user selection - ignore that no-op emission so it doesn't
    // re-trigger a save/breakdown fetch that already happened on page load.
    const formatted = this.datePipe.transform(event, 'yyyy-MM-dd');
    if (formatted === this.datePipe.transform(this.selectedInceptionDate, 'yyyy-MM-dd')) {
      return;
    }

    this.selectedInceptionDate = event;
    this.ref.detectChanges();
    const question = new Question();
    question.cent_aq_question_id = 571;
    question.answer = formatted;
    this.questionService.saveAnswerOnly(question)
      .subscribe(() => {
        this.getPaymentBreakdown();
      });
  }

  get selectedFrequency(): any {
    return this.payFrequencies.find(f => f.frequency_id === this.selectedFrequencyId) || null;
  }

  isCreditCard(method: any): boolean {
    return !!method?.pay_type_name?.toLowerCase().match(/credit|card/);
  }

  isDebitOrder(method: any): boolean {
    return !!method?.pay_type_name?.toLowerCase().includes('debit');
  }

  get payButtonDisabled(): boolean {
    if (!this.legalAgreed || this.processingPayment) {
      return true;
    }
    const method = this.selectedPaymentMethod;
    if (!method) {
      return true;
    }
    if (method.entry_type === 'new') {
      if (this.isDebitOrder(method)) {
        return !method.bank_verified;
      }
      // new credit card / EFT / other payment types aren't captured by the form yet
      return true;
    }
    return false;
  }

  gotToNext(): void {
    if (this.payButtonDisabled) {
      return;
    }

    // resolvedProductId comes back from getPaymentBreakDownData, which derives it server-side
    // from calc_collation; selectedProduct is only a sessionStorage cache from the earlier "pick
    // cover" step, so it's empty if this page is reached without that step running first in this
    // tab (e.g. a resumed/consent-link session in a fresh browser). Falling through with neither
    // set would reach the backend as the literal string "undefined" for a SQL int parameter and
    // fail with a cryptic "Error converting data type nvarchar to int."
    const productId = +(this.resolvedProductId ?? this.selectedProduct?.product_id);
    if (!productId) {
      console.error('gotToNext: no product_id available', {
        resolvedProductId: this.resolvedProductId,
        selectedProduct: this.selectedProduct
      });
      Alert('We couldn\'t confirm which product you\'re paying for. Please refresh the page and try again.');
      return;
    }

    this.processingPayment = true;
    this.questionService.spinner(true);

    const termsQuestion = new Question();
    termsQuestion.cent_aq_question_id = 2882;
    termsQuestion.answer = JSON.stringify({
      ip_address: localStorage.getItem('ip_address'),
      terms: true
    });
    this.questionService.saveAnswerOnly(termsQuestion).subscribe();

    const createProfileParameters = new Map<string, string>();
    createProfileParameters.set('session_id', this.sessionDetails.session_id);
    createProfileParameters.set('category_id', `${this.sessionDetails.category_id}`);
    createProfileParameters.set('product_group_id', `${this.sessionDetails.group_id}`);

    this.questionService.runCommandNew('createProfile', createProfileParameters).subscribe({
      next: (person: any[]) => {
        const personId = person[0].person_id;

        const createPolicyParameters = new Map<string, string>();
        createPolicyParameters.set('product_id', `${productId}`);
        createPolicyParameters.set('person_id', personId);
        createPolicyParameters.set('date_inception', this.selectedInceptionDate);
        createPolicyParameters.set('debit_date', this.selectedInceptionDate);
        createPolicyParameters.set('frequency', '3');
        createPolicyParameters.set('first_debit', this.selectedInceptionDate);
        createPolicyParameters.set('session_id', this.sessionDetails.session_id);

        this.questionService.runCommandNew('createPolicy', createPolicyParameters).subscribe({
          next: (policy: any[]) => {
            const policyId = policy[0].policy_id;
            this.savePaymentMethod(personId, policyId);

            const triggerEventParameters = new Map<string, string>();
            triggerEventParameters.set('event_id', '1');
            triggerEventParameters.set('session_id', this.sessionDetails.session_id);
            this.questionService.runCommandNew('triggerEvent', triggerEventParameters).subscribe({
              next: () => {
                this.questionService.spinner(false);
                if (this.user?.broker_id > 0 || this.user?.console_access) {
                  this.router.navigate(['/everything.policy-holders']);
                } else {
                  this.router.navigate(['/quote-outstanding']);
                }
              },
              error: () => {
                this.questionService.spinner(false);
                this.processingPayment = false;
              }
            });
          },
          error: () => {
            this.questionService.spinner(false);
            this.processingPayment = false;
            Alert('We were unable to create your policy. Please try again.');
          }
        });
      },
      error: () => {
        this.questionService.spinner(false);
        this.processingPayment = false;
        Alert('We were unable to process your details. Please try again.');
      }
    });
  }

  private buildBankingJson(method: any): any {
    if (method.entry_type === 'existing') {
      return {person_bank_id: method.person_bank_id};
    }
    if (this.isDebitOrder(method)) {
      return {
        transaction_type: PaymentDetailsTransactionTypes.Debit_Order,
        bank_id: method.bank_id,
        bank_name: method.bank_name,
        branch_code: method.branch_code,
        acc_type: this.accountTypes.find(a => a.value === String(method.account_type_id))?.label,
        acc_name: method.account_name,
        acc_no: method.account_number
      };
    }
    return null;
  }

  private savePaymentMethod(personId: number, policyId: number): void {
    const bankingJson = this.buildBankingJson(this.selectedPaymentMethod);
    if (!bankingJson) {
      return;
    }

    const parameters = new Map<string, string>();
    parameters.set('person_id', String(personId));
    parameters.set('bankingDetails_JSON', JSON.stringify(bankingJson));
    this.questionService.runCommandNew('savePerson_bank', parameters).subscribe(resp => {
      const relParameters = new Map<string, string>();
      relParameters.set('person_bank_id', String(resp[0].person_bank_id));
      relParameters.set('policy_id', String(policyId));
      this.questionService.runCommandNew('savePerson_bank_policy_rel', relParameters).subscribe();
    });
  }

  goBack(): void {
    this.navigateBack.emit();
  }

  ngOnDestroy(): void {

  }
}
